import classNames from 'classnames'
import Carousel from 'components/Carousel'
import style from './style.module.scss'
import DashboardHighlight from 'components/DashboardHighlight'
import { DashboardHighlight as Highlight } from 'types'

export type DashboardHighlightsProps = {
  highlights: Highlight[]
  affiliateId: string
  affiliateSlug: string
}

export default function DashboardHighlights({
  highlights,
  affiliateId,
  affiliateSlug,
}: DashboardHighlightsProps) {
  return (
    <Carousel
      slideId='keen-slider__slide-highlights'
      slidesPerView={1}
      numItems={2}
      arrowDisplayType='boxed-right'
    >
      {highlights.map((highlight) => (
        <div
          className={classNames(
            style.highlightContainer,
            `keen-slider__slide-highlights`,
          )}
          key={highlight.headlineText}
        >
          <DashboardHighlight
            highlight={highlight}
            affiliateId={affiliateId}
            affiliateSlug={affiliateSlug}
          />
        </div>
      ))}
    </Carousel>
  )
}
